import { COVERGO_SAAS_DEV, COVERGO_ASIA_PROD } from "../consts.js"

export const bocl = {
	"bocl-uat-studio.quote.hk": {
		appConfig: {
			tenantId: "bocl_uat",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	},
	"bocl-dev-studio.quote.hk": {
		appConfig: {
			tenantId: "bocl_dev",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	},
	"bocl-prod-studio.quote.hk": {
		appConfig: {
			tenantId: "bocl_prod",
			appId: "admin_portal"
		},
		envConfig: COVERGO_ASIA_PROD
	}

}
